import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HIGHLIGHTS = ['Prix connu à l’avance', 'Créneau au choix', 'Professionnel qualifié'];
const BENEFITS = ['Paiement sécurisé', 'Confirmation immédiate par SMS et e-mail'];

const delay = (ms) => ({ '--reveal-delay': `${ms}ms` });

const HeroSection = ({ onBookService }) => {
  return (
    <section
      className="relative flex items-center justify-center overflow-hidden py-14 sm:py-20 hero-fullscreen"
      style={{
        backgroundImage: 'url(/images/hero-plombier.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: '70% center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(100deg, rgba(3, 15, 22, 0.95) 0%, rgba(6, 30, 40, 0.88) 50%, rgba(6, 24, 33, 0.72) 100%)',
        }}
      />
      <div className="hero-drift" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
        <div className="reveal-on-load marketing-kicker gap-2 mb-5 mx-auto normal-case tracking-normal text-sm">
          <Icon name="ShieldCheck" size={16} />
          <span>Professionnels certifiés et assurés</span>
        </div>

        <h1
          className="reveal-on-load marketing-title text-3xl sm:text-5xl lg:text-6xl font-heading font-extrabold leading-[1.1] mb-4"
          style={delay(150)}
        >
          Un problème de plomberie&nbsp;?
        </h1>

        <p
          className="reveal-on-load marketing-accent text-lg sm:text-2xl font-semibold leading-snug mb-4"
          style={delay(300)}
        >
          Décrivez votre problème en quelques clics.
        </p>

        <ul
          className="reveal-on-load flex flex-wrap justify-center gap-x-2 gap-y-1 text-sm sm:text-base text-cyan-50/80 mb-7"
          style={delay(450)}
        >
          {HIGHLIGHTS.map((label, i) => (
            <li key={label} className="flex items-center gap-2">
              {i > 0 && <span aria-hidden="true" className="text-cyan-300/60">·</span>}
              {label}
            </li>
          ))}
        </ul>

        <div className="reveal-on-load" style={delay(600)}>
          <Button
            variant="default"
            size="xl"
            iconName="Wrench"
            onClick={onBookService}
            className="hero-cta shadow-lg w-full sm:w-auto sm:min-w-[300px]"
          >
            Décrire mon problème
          </Button>
        </div>

        <ul className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2 text-sm text-cyan-50">
          {BENEFITS.map((label, i) => (
            <li
              key={label}
              className="reveal-on-load flex items-center gap-1.5"
              style={delay(750 + i * 100)}
            >
              <Icon name="CheckCircle2" size={16} className="text-emerald-400 shrink-0" />
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HeroSection;
